import * as tslib_1 from "tslib";
import { OnChanges, OnDestroy, OnInit, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import notify from 'devextreme/ui/notify';
import intersection from 'lodash-es/intersection';
import { combineLatest, iif, of } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { ExtLoopBackAuth } from '../../../../shared/modules/ext-sdk/services/ext-sdk-auth.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseModelPaneWToolbarComponent } from '../../../../shared/modules/ui/components/abstract/a-base-model-pane-w-toolbar.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { Employee, EmployeeApi, LoggerService, LoopBackFilter, Person } from '../../../../shared/sdk';
import { DlgAssignFacilityComponent } from '../../dialogs/dlg-assign-facility/dlg-assign-facility.component';
import { DlgCreateAccountComponent } from '../../dialogs/dlg-create-account/dlg-create-account.component';
import { HelperService } from '../../services/helper.service';
import { EmployeeFormComponent } from '../employee-form/employee-form.component';
export class EmployeeDetailsTabProfileComponent extends ABaseModelPaneWToolbarComponent {
    constructor(config, logger, ui, helper, dss, dialog, auth) {
        super(logger, ui, dss);
        this.config = config;
        this.logger = logger;
        this.ui = ui;
        this.helper = helper;
        this.dss = dss;
        this.dialog = dialog;
        this.auth = auth;
        this.canAssignFacility = false;
        this.canCreateAccount = false;
        this.canSeeSsn4 = false;
        this.canEditSsn = false;
        this.loadingSsn = false;
        this.editSsn = false;
        this.ssnText = '';
        this.caption = 'Person Info';
        this.model$
            .pipe(
        // tap(console.log),
        switchMap(model => iif(() => !!model, // && !!model.userId,
        of(model).pipe(switchMap(m => combineLatest([
            this.config.tenantType$,
            this.config.roles$,
        ])), map(([tType, myRoles,]) => {
            // const onBASE = this.auth.getCurrentTenant() === 7; // TODO: hardcode
            const onBASE = tType === 'BASE';
            const hasRole1 = intersection(myRoles, ['SU', 'ADMIN', 'HR_ADMIN', 'ASSIGN_FACILITY_TO_EMPLOYEE']).length > 0;
            const hasRole2 = intersection(myRoles, ['SU', 'ADMIN', 'HR_ADMIN']).length > 0;
            const canSeeSsn4 = intersection(myRoles, ['HR_CLERK']).length > 0;
            const canEditSsn = intersection(myRoles, ['HR_ADMIN', 'HR_MANAGER']).length > 0;
            return [
                onBASE && hasRole1,
                // &&
                // eRoles.includes('DRIVER') &&
                // eRoles.filter((r: string) => !r.startsWith('$')).length === 1
                onBASE && hasRole2,
                onBASE && (canSeeSsn4 || canEditSsn),
                onBASE && canEditSsn,
            ];
        })), of([false, false, false, false]))), tap(([can1, can2, canSeeSsn4, canEditSsn]) => {
            this.canAssignFacility = can1;
            this.canCreateAccount = can2;
            this.canSeeSsn4 = canSeeSsn4;
            this.canEditSsn = canEditSsn;
            this.editSsn = false;
            this.ssnText = '';
        }), catchError(err => {
            console.error(err);
            return of(null);
        }), takeUntil(this.$onDestroy$))
            .subscribe();
    }
    get ModelClass() {
        return Employee;
    }
    get FormComponent() {
        return EmployeeFormComponent;
    }
    get filter() {
        return {
            include: [
                { person: [{ contact: ['addresses', 'phones', 'emails'] }, 'personalPhoto'] },
                { emRelations: { person: { contact: ['addresses', 'phones', 'emails'] } } },
                'user',
                'employeePosition',
            ],
        };
    }
    get observeModels() {
        return [this.ModelClass, Person];
    }
    ngOnInit() {
        super.ngOnInit();
    }
    editSsn_onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.canEditSsn) {
                notify('To see full SSN need role "HR Manager"', 'error', 5000);
                return;
            }
            this.loadingSsn = true;
            this.ssnText = '';
            try {
                this.ssnText = yield this.dss.getApi(Employee).getEmployeeSSN(this.modelId).toPromise();
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.editSsn = true;
                this.loadingSsn = false;
            }
        });
    }
    saveSsn_onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.ssnText.length < 9) {
                return notify('Invalid SSN', 'error', 5000);
            }
            this.loadingSsn = true;
            try {
                this.model.ssnLast4Digits = yield this.dss
                    .getApi(Employee)
                    .updateEmployeeSSN(this.modelId, this.ssnText)
                    .toPromise();
                notify('SSN updated', 'success', 5000);
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.editSsn = false;
                this.loadingSsn = false;
            }
        });
    }
    reassignTenant_onClick() {
        void this.dialog
            .open(DlgAssignFacilityComponent, {
            hasBackdrop: true,
            width: '600px',
            minWidth: 400,
            data: {
                model: this.model,
                userId: oc(this.model).userId(),
            },
        })
            .afterClosed()
            .pipe(switchMap(v => iif(() => !!v, of(v).pipe(tap(() => this.ui.showLoading()), catchError(err => of(notify(err.message, 'error', 5000))), tap(() => this.ui.hideLoading())))))
            .toPromise();
    }
    createAccount_onClick() {
        void this.dialog
            .open(DlgCreateAccountComponent, {
            hasBackdrop: true,
            width: '600px',
            minWidth: 400,
            data: {
                model: this.model,
            },
        })
            .afterClosed()
            .pipe(switchMap(v => iif(() => !!v, of(v).pipe(tap(() => this.ui.showLoading()), tap(() => this.refresh()), tap(() => this.reassignTenant_onClick()), catchError(err => of(notify(err.message, 'error', 5000))), tap(() => this.ui.hideLoading())))))
            .toPromise();
    }
}
